var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside"},_vm._l((_vm.menuList),function(item,index){return _c('div',{key:index,class:['menu-item', _vm.isActive.split('/')[1] == item.path.split('/')[1] ? 'isActive' : ''],on:{"click":function($event){return _vm.clickMenu(item)}}},[_c('i',{class:item.icon}),_c('span',[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }